module.exports = "<p>\r\n  mock works!\r\n</p>\r\n"